import React, { useEffect } from 'react'
import { Navigate, useParams } from 'react-router-dom'
import { CasinoUiProvider } from '../../context/CasinoUiContext'
import LotusCasinoShell from '../../components/LotusCasinoShell/LotusCasinoShell'
import LotusCasinoPlayRouter from '../../components/LotusCasinoShell/LotusCasinoPlayRouter'
import { getLotusTabByIndex } from '../../constants/lotusCasinoTabs'

const scrollCasinoPageToTop = () => {
  window.scrollTo(0, 0)
  document.documentElement.scrollTop = 0
  document.body.scrollTop = 0
  document.querySelectorAll('.desktop-main-content').forEach((el) => {
    ;(el as HTMLElement).scrollTop = 0
  })
}

const LotusCasinoTabPage = () => {
  const { tabId } = useParams<{ tabId: string }>()
  const tabIndex = parseInt(tabId ?? '1', 10)
  const tab = getLotusTabByIndex(tabIndex)

  // Super Casino cards sit mid-page; keep prior scroll unless we reset on tab entry.
  useEffect(() => {
    scrollCasinoPageToTop()
    const t = window.setTimeout(scrollCasinoPageToTop, 0)
    return () => window.clearTimeout(t)
  }, [tabId])

  if (!tab) {
    return <Navigate to="/casino-int/tab/1" replace />
  }

  if (tab.targetType === 'route' && !tab.casinoType) {
    return <Navigate to={tab.target} replace />
  }

  const category =
    tab.targetType === 'category'
      ? tab.target
      : tab.defaultCategory ?? null

  return (
    <CasinoUiProvider>
      <LotusCasinoPlayRouter defaultCategory={category} />
      <LotusCasinoShell activeTabIndex={tabIndex} />
    </CasinoUiProvider>
  )
}

export default LotusCasinoTabPage
